
import { ImagePreview } from 'vant';
import SupTaskReport from '../driver/sup-task-report';
import CleanTaskLogList from './clean-task-log-list';
import ModifyPwd from '../employee/modify-pwd.vue';
import Checkin from './checkin.vue'
import Supplement from './supplement.vue';
import V3 from './v3.vue';
import Chat from '../im/chat.vue';
import Setting from './setting.vue';
import SupTasks from '../driver/sup-tasks.vue';

export default {
    components: {
        SupTaskReport,
        CleanTaskLogList,
        ModifyPwd,
        Checkin,
        Supplement,
        V3,
        Chat,
        Setting,
        SupTasks
    },
    async created() {

        let t = this;

        t.todayDateStr = (new Date()).format('yyyy. MM. dd');

        t.$eventBus.$on('refresh-unread', (append, v) => {
            if (append) {
                t.stats.unread += v;
                t.stats._tick++;
            }
            else {
                t.stats.unread = v;
                t.stats._tick++;
            }
        });

        t.setAppMode('cleaner');

        window._language = 'ja-jp';

        t.list.country = window['COUNTRY_LIST'];

        t.list.country.forEach(item => {
            item.icon = 'assets/img/flag/' + item.code + '.svg';
        });

        t.dict.country = listToDict(t.list.country, 'code');

        await axios.get('cleanArea?_with=items').then(res => {
            if (res.data.status == 1) {
                let items = res.data.options.items;
                items.forEach(item => {
                    item.remark = '';
                });
                t.list.cleanArea = items;
                t.dict.cleanArea = listToDict(items);
            }
        });

        await t.refreshProfile();

        let p = t.$route.query;

        if (p.v) {
            t.setView(p.v);
        }
        else {
            if (t.U.grant.clean_mgr == 1) {
                t.setView('checkin');
            }
            else if (t.U.is_cleaner == 1) {
                t.setView('tasks');
            }
            else if (t.U.is_driver == 1) {
                t.setView('sup-tasks');
            }
        }

        if (document.getElementById('realtimeStr'))
            document.getElementById('realtimeStr').innerText = (new Date()).format('hh:mm:ss');

        setInterval(function () {
            if (document.getElementById('realtimeStr'))
                document.getElementById('realtimeStr').innerText = (new Date()).format('hh:mm:ss');
        }, 1000);

        if (window.timerRefreshStats) {
            clearInterval(window.timerRefreshStats);
            window.timerRefreshStats = null;
        }

        window.timerRefreshStats = setInterval(() => {
            t.loadStats();
        }, 5000);

        t.loadStats();

    },
    beforeDestroy() {
        if (window.timerRefreshStats) {
            clearInterval(window.timerRefreshStats);
            window.timerRefreshStats = null;
        }
        if(window.intervalLoadAppendData){
            clearInterval(window.intervalLoadAppendData);
            window.intervalLoadAppendData = null;
        }
    },
    activated() {

        let t = this;

        copyFrom(t.f, t.U);

        if (t.U.birthday) {
            let arr = t.U.birthday.split('-');
            t.f.birthday_year = arr[0];
            t.f.birthday_month = arr[1];
            t.f.birthday_day = arr[2];
        }

    },
    methods: {

        loadStats() {

            let t = this;

            t.lastJSON = '';

            axios.get('im/getStats').then(res => {
                if (res.data.status == 1) {
                    let json = JSON.stringify(res.data.options);

                    if (json != t.lastJSON) {
                        t.lastJSON = json;
                        let unread = Object.keys(res.data.options.user_unread).length + Object.keys(res.data.options.group_unread).length;
                        if (unread != t.stats.unread) {
                            t.stats.unread = unread;
                            t.stats._tick++;
                        }
                        if(res.data.options.clean_task_sendback_report != t.stats.clean_task_sendback_report){
                            t.stats.clean_task_sendback_report = res.data.options.clean_task_sendback_report;
                            t.stats._tick++;
                            t.loadData();
                        }
                        if(res.data.options.today_unfinished_clean_task != t.stats.today_unfinished_clean_task){
                            t.stats.today_unfinished_clean_task = res.data.options.today_unfinished_clean_task;
                            t.stats._tick++;
                        }
                        if (unread > 0)
                            t.$refs.chat.syncUnread(res.data.options);
                    }
                }
            });

        },

        goSetting() {
            this.oldView = this.view;
            this.view = 'setting';
        },

        goIM() {
            this.view = 'chat';
        },

        logout() {
            clearLocalStorage();
            location.reload('/#/signIn');
        },

        async refreshProfile() {

            let t = this;

            await axios.post('employee/refreshProfile').then(res => {
                if (res.data.status == 1) {
                    if (!res.data.options.item) {
                        localStorage.removeItem('_m');
                        location.replace('/#/signin');
                    }
                    else {
                        localStorage['_m'] = JSON.stringify(res.data.options.item);
                        mirror(res.data.options.item, t.U);
                        copyFrom(t.f, t.U);


                        if (t.U.birthday) {
                            let arr = t.U.birthday.split('-');
                            t.f.birthday_year = arr[0];
                            t.f.birthday_month = arr[1];
                            t.f.birthday_day = arr[2];
                            t.selectedDate = new Date(t.U.birthday);
                        }

                        if (!t.U.rating)
                            t.U.rating = 4;
                    }
                }
            });

        },

        loadData() {
            let t = this;

            let date = (new Date()).format('yyyy-MM-dd');

            axios.get('cleanTask?_self=1&_with=room,order,results,roomCleanAreas&date=' + date).then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;

                    arr.forEach(item => {
                        item.emergency = false;
                        if (item.status == 1 && (new Date()).getHours() >= 13)
                            item.emergency = true;
                    });

                    t.list.cleanTask = arr;

                    t.list.startedCleanTask = t.list.cleanTask.filter(item => item.status != 1);
                }
            });
        },

        loadAppendData() {
            let t = this;

            let date = (new Date()).format('yyyy-MM-dd');

            let ids = t.list.cleanTask.map(item => item.id).join(',');

            axios.get('cleanTask?_self=1&_with=room,order,results,roomCleanAreas&date=' + date+'&excludedIds='+ids).then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;

                    arr.forEach(item => {
                        item.emergency = false;
                        if (item.status == 1 && (new Date()).getHours() >= 13)
                            item.emergency = true;
                        t.list.cleanTask.push(item);
                    });

                    t.list.startedCleanTask = t.list.cleanTask.filter(item => item.status != 1);
                }
            });
        },

        refreshTaskTabs() {

            let t = this;

            t.list.startedCleanTask = t.list.cleanTask.filter(item => item.status != 1);
        },

        setView(v) {

            let t = this;

            if (v == t.view)
                return;

            if (v == 'report') {
                let tasks = t.list.startedCleanTask;
                if (tasks.length < 1)
                    A.toast('No cleaning tasks started', 1000, 'info');
                else {
                    t.editTaskItem(tasks[0]);
                }

                return;
            }

            if (v == 'tasks') {
                t.loadData();
                if(window.intervalLoadAppendData)
                    clearInterval(window.intervalLoadAppendData);

                window.intervalLoadAppendData = setInterval(() => {
                    t.loadAppendData();
                }, 5000);
                axios.get('cleanTaskLog/stats').then(res => {
                    if (res.data.status == 1) {
                        let stats = res.data.options.stats;
                        t.ctl.total = Number(stats.cancel) + Number(stats.new) + Number(stats.update);
                    }
                });
            }

            if (v == 'attendance') {
                t.loadMonthlyStats();
            }

            t.view = v;

        },

        setStatus(item, status) {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.put('cleanTask/' + item.id, { 'status': status }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    item.status = status;

                    if (status == 2) {
                        t.refreshTaskTabs();
                        t.view = 'report';
                        t.editTaskItem(item);
                    }
                }
            });

        },

        setFinish(item) {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.put('cleanTask/' + item.id, { 'is_finish': 1 }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    t.list.cleanTask.remove(item);
                    t.refreshTaskTabs();

                }
            });

        },

        editTaskItem(item) {
            let t = this;
            t.currentTask = item;

            let arr = [];

            let selectedIds = [];
            let dictAreaImgs = {};
            let dictAreaRemark = {};
            let dictAreaPassed = {};
            let dictAreaPrev = {};

            if (t.currentTask.results && t.currentTask.results.length > 0) {
                let dictArea = {};
                t.currentTask.results.forEach(res => {
                    dictArea[res.area_id] = res;
                    dictAreaPassed[res.area_id] = (res.passed_imgs || '').split(',').filter(u => u);
                    dictAreaPrev[res.area_id] = (res.prev_img_urls || '').split(',');
                    // if (res.selection) {
                    //     selectedIds.append(res.selection.split(','));
                    // }
                    // if (res.img_urls) {
                    //     dictAreaImgs[res.area_id] = res.img_urls.split(',');
                    // }
                });

                localStorage['task_tmp_' + t.currentTask.id] = JSON.stringify(dictArea);
            }

            let taskResults = localStorage['task_tmp_' + t.currentTask.id];

            if (taskResults) {

                taskResults = JSON.parse(taskResults);

                t.dict.editingTask[t.currentTask.id] = taskResults;

                let results = [];

                for (const k in taskResults) {
                    results.push(taskResults[k]);
                }

                results.forEach(res => {
                    if (res.selection) {
                        selectedIds.append(res.selection.split(','));
                    }
                    if (res.img_urls) {
                        dictAreaImgs[res.area_id] = res.img_urls.split(',');
                    }
                    if (res.remark) {
                        dictAreaRemark[res.area_id] = res.remark;
                    }
                });
            }

            let dictRCA = {};

            t.currentTask.room_clean_areas.forEach(rca => {
                dictRCA[rca.area_id] = rca;
            });

            t.list.cleanArea.forEach(area => {

                area.imgs = [];
                area.columns = [];
                area.passedImgs = dictAreaPassed[area.id] || [];
                area.prevImgs = dictAreaPrev[area.id] || [];
                area.showPrev = [];

                area.items.forEach(item => {
                    item.selected = false;

                    if (selectedIds.indexOf(item.id.toString()) > -1)
                        item.selected = true;
                });

                if (dictAreaImgs[area.id]) {
                    area.imgs = dictAreaImgs[area.id];
                }

                if (dictAreaRemark[area.id]) {
                    area.remark = dictAreaRemark[area.id];
                }

                if (area.column == 1) {
                    area.columns.push(area.items);
                }
                else if (area.column == 2) {
                    let rows = area.rows.split(',');
                    area.columns.push(area.items.slice(0, Number(rows[0])));
                    area.columns.push(area.items.slice(Number(rows[0]), Number(rows[1]) + Number(rows[0])));
                }

                let rca = dictRCA[area.id];

                if (rca && rca.quantity > 0) {
                    area.quantity = rca.quantity;
                    arr.push(area);
                }

            });

            t.list.roomArea = arr;

            t.view = 'report';
        },

        updateArea(area) {

            let t = this;

            t.$forceUpdate();
            let selectedIds = [];

            area.items.forEach(item => {
                if (item.selected)
                    selectedIds.push(item.id);
            });

            let f = {
                task_id: t.currentTask.id,
                area_id: area.id,
                selection: selectedIds.join(',')
            };

            if (!t.dict.editingTask[t.currentTask.id])
                t.dict.editingTask[t.currentTask.id] = {};

            if (t.dict.editingTask[t.currentTask.id][area.id])
                t.dict.editingTask[t.currentTask.id][area.id].selection = f.selection;
            else
                t.dict.editingTask[t.currentTask.id][area.id] = f;

            localStorage['task_tmp_' + t.currentTask.id] = JSON.stringify(t.dict.editingTask[t.currentTask.id]);

            // axios.post('cleanTask/saveResult', f).then(res => {
            //     if (res.data.status == 1) {

            //     }
            // });


        },

        uploadPicture(area) {

            let t = this;

            t.list.blobs.clear();

            ImageUploader.onSelectImage = null;
            ImageUploader.onSelectImages = (files) => {

                if (files.size > 6) {
                    A.err('No more than 6 images can be selected at a time');
                    return;
                }

                t.list.uploadQueue.clear();

                for (let i = 0; i < files.length; i++) {
                    t.list.uploadQueue.push(files[i]);
                }

                if (t.list.uploadQueue.length > 0) {
                    t.loading = true;
                    t.startScale(area);
                }

            };

            ImageUploader.openSelector(true);
        },

        takePicture(area) {

            let t = this;

            t.list.blobs.clear();

            ImageUploader.onSelectImages = null;
            ImageUploader.onSelectImage = (file) => {

                if (file) {
                    t.list.uploadQueue.clear();

                    t.list.uploadQueue.push(file);

                    if (t.list.uploadQueue.length > 0) {
                        t.loading = true;
                        t.startScale(area);
                    }

                }
            };

            ImageUploader.openCamera();

        },

        startScale(area) {
            let t = this;

            if (t.list.uploadQueue.length > 0) {

                const file = t.list.uploadQueue[0];

                const reader = new FileReader();

                reader.onload = function (e) {

                    const img = new Image();

                    img.src = e.target.result;

                    img.onload = function () {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');

                        // 设置最大宽度和高度
                        const maxWidth = 1920;
                        const maxHeight = 1920;

                        let width = img.width;
                        let height = img.height;

                        // 计算缩放比例
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }

                        if (height > maxHeight) {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }

                        // 设置 canvas 大小
                        canvas.width = width;
                        canvas.height = height;

                        // 在 canvas 上绘制缩放后的图像
                        ctx.drawImage(img, 0, 0, width, height);

                        // 生成 Blob
                        canvas.toBlob(blob => {

                            t.list.blobs.push(blob);

                            t.list.uploadQueue.shift();

                            if (t.list.uploadQueue.length > 0) {
                                t.startScale(area);
                            }
                            else {
                                t.startUpload(area);
                            }

                        }, 'image/webp', 0.2);
                    };

                };

                reader.readAsDataURL(file);

            }
        },

        startUpload(area) {

            let t = this;
            let fd = new FormData();
            let idx = 0;

            t.list.blobs.forEach(blob => {
                fd.append('image_' + idx, blob);
                idx++;
            });

            fd.append('qty', idx);
            fd.append('task_id', t.currentTask.id);

            axios.post('cleanTask/saveMultipleImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {

                if (res.data.status == 1) {

                    let urls = res.data.options.img_urls;
                    if (typeof t.replacingIndex === 'number') {
                        let newUrl = urls;
                        if (Object.prototype.toString.call(urls) === '[object Array]') {
                            newUrl = urls.length > 0 ? urls[0] : '';
                        } else if (typeof urls === 'string') {
                            newUrl = urls.split(',')[0];
                        }
                        t.$set(area.imgs, t.replacingIndex, newUrl);
                    } else {
                        area.imgs.append(urls);
                    }

                    t.$forceUpdate();

                    let selectedIds = [];

                    area.items.forEach(item => {
                        if (item.selected)
                            selectedIds.push(item.id);
                    });

                    let f = {
                        task_id: t.currentTask.id,
                        area_id: area.id,
                        img_urls: area.imgs.join(','),
                        selection: selectedIds.join(',')
                    };

                    if (!t.dict.editingTask[t.currentTask.id])
                        t.dict.editingTask[t.currentTask.id] = {};

                    t.dict.editingTask[t.currentTask.id][area.id] = f;

                    localStorage['task_tmp_' + t.currentTask.id] = JSON.stringify(t.dict.editingTask[t.currentTask.id]);

                    t.replacingIndex = null;
                    t.loading = false;

                    // t.updateArea(area);
                    // axios.post('cleanTask/saveResult', f).then(res => {
                    //     if (res.data.status == 1) {
                    //         t.loading = false;
                    //     }
                    // });

                }
            });

        },

        displayImg(area, j) {
            if (area.showPrev && area.showPrev[j] && area.prevImgs && area.prevImgs[j])
                return area.prevImgs[j];
            return area.imgs[j];
        },

        isPassed(area, j) {
            if (!area.passedImgs || !area.imgs || !area.imgs[j])
                return false;
            return area.passedImgs.indexOf(area.imgs[j]) > -1;
        },

        isReturned() {
            return this.currentTask && this.currentTask.is_finish == 2;
        },

        togglePrev(area, j) {
            let t = this;
            if (!area.prevImgs || !area.prevImgs[j])
                return;
            if (!area.showPrev)
                area.showPrev = [];
            t.$set(area.showPrev, j, !area.showPrev[j]);
        },

        resubmitPhoto(area, j) {
            let t = this;
            if (!t.isReturned() || t.isPassed(area, j) || (area.showPrev && area.showPrev[j]))
                return;
            if (t.loading)
                return;

            Swal.mixin({
                customClass: {
                    confirmButton: 'btn-lg btn-orange',
                    cancelButton: 'btn-sm btn-dark mr10'
                },
                confirmButtonText: '撮る',
                cancelButtonText: '写真',
                buttonsStyling: false,
                showCancelButton: true,
            }).fire('やり直してから、もう一度写真を提出してください。', '').then(res => {
                if (res.isConfirmed) {
                    t.replacingIndex = j;
                    t.takePicture(area);
                } else if (res.dismiss === 'cancel') {
                    t.replacingIndex = j;
                    t.list.blobs.clear();
                    ImageUploader.onSelectImage = null;
                    ImageUploader.onSelectImages = (files) => {
                        if (!files || files.length < 1)
                            return;
                        t.list.uploadQueue.clear();
                        t.list.uploadQueue.push(files[0]);
                        t.loading = true;
                        t.startScale(area);
                    };
                    ImageUploader.openSelector(false);
                }
            });
        },

        removeImg(area, img) {


            let t = this;
            if (t.isReturned())
                return;
            if (area.passedImgs && area.passedImgs.indexOf(img) > -1)
                return;
            area.imgs.remove(img);
            t.$forceUpdate();

            let selectedIds = [];

            area.items.forEach(item => {
                if (item.selected)
                    selectedIds.push(item.id);
            });

            let f = {
                task_id: t.currentTask.id,
                area_id: area.id,
                img_urls: area.imgs.join(','),
                selection: selectedIds.join(',')
            };

            if (!t.dict.editingTask[t.currentTask.id])
                t.dict.editingTask[t.currentTask.id] = {};

            t.dict.editingTask[t.currentTask.id][area.id] = f;

            localStorage['task_tmp_' + t.currentTask.id] = JSON.stringify(t.dict.editingTask[t.currentTask.id]);


        },

        preview(area, idx) {

            let t = this;
            let imgUrls = [];

            if (area.imgs && area.imgs.length > 0) {
                for (let j = 0; j < area.imgs.length; j++) {
                    imgUrls.push(t.url(t.displayImg(area, j)));
                }

                ImagePreview({
                    images: imgUrls,
                    startPosition: idx,
                    closeable: true,
                });
            }
        },

        showPhotoActions(area, j, img) {
            let t = this;
            if (t.isReturned() || t.isPassed(area, j)) {
                t.preview(area, j);
                return;
            }
            Swal.mixin({
                customClass: {
                    confirmButton: 'btn-lg btn-orange',
                    cancelButton: 'btn-sm btn-dark mr10'
                },
                confirmButtonText: 'View',
                cancelButtonText: 'Remove',
                buttonsStyling: false,
                showCancelButton: true,
            }).fire('Photo Handle', '').then(res => {
                if (res.isConfirmed) {
                    t.preview(area, j);
                }
                else if (res.isDismissed) {
                    t.removeImg(area, img);
                }
            });
        },
        submit() {
            let t = this;

            if (t.busying)
                return;

            let taskResults = localStorage['task_tmp_' + t.currentTask.id];

            if (!taskResults) {
                A.err('空のコンテンツを送信しないでください');
                return;
            }

            taskResults = JSON.parse(taskResults);

            let results = [];

            for (const k in taskResults) {
                results.push(taskResults[k]);
            }

            A.safety('再確認をお願いします。').then(res => {
                if (res.isConfirmed) {

                    let dictAreaRemark = {};

                    let go = true;
                    t.list.cleanArea.forEach(area => {
                        dictAreaRemark[area.id] = area.remark;
                    });

                    t.list.roomArea.forEach(area => {
                        if (!go) {
                            return;
                        }
                        if (area.imgs.length < 1) {
                            A.err(area.name + '-画像をアップロードしてください');
                            go = false;
                            return;
                        }
                        if (t.isReturned() && area.passedImgs && area.passedImgs.length > 0) {
                            for (let p = 0; p < area.passedImgs.length; p++) {
                                if (area.imgs.indexOf(area.passedImgs[p]) < 0) {
                                    A.err(area.name + '-合格済みの写真を保持してください');
                                    go = false;
                                    return;
                                }
                            }
                        }
                    });

                    if (!go) {
                        return;
                    }

                    results.forEach(res => {
                        let areaId = res.area_id;
                        if (dictAreaRemark[areaId]) {
                            res.remark = dictAreaRemark[areaId];
                        }
                    });

                    t.busying = true;

                    axios.post('cleanTask/saveResults', { 'results': results }).then(res => {
                        t.busying = false;
                        if (res.data.status == 1) {
                            localStorage.removeItem('task_tmp_' + t.currentTask.id);
                            t.setStatus(t.currentTask, 3);
                            t.view = 'tasks';
                        }
                    });


                }
            });

        },

        tapAreaItem(item, area) {
            let t = this;
            if (t.currentTask.status == 3) { A.err('提出済み、編集不可'); return; }
            item.selected = !item.selected;
            t.updateArea(area);
        },

        onSelectDate() {
            this.f.birthday = this.selectedDate.format('yyyy-MM-dd');
            this.showCalendar = false;
            this.$forceUpdate();
        },

        closeCropper() {
            $('.cropper-item').hide();
        },

        confirmCropper() {

            let t = this;

            t.cropper.getCroppedCanvas({
                minHeight: 600,
                minWdith: 600,
                maxHeight: 1000,
                maxWdith: 1000,
                fillColor: '#fff',
            }).toBlob((blob) => {

                if (t.uploadImgType == 'rc') {
                    t.rcImageBlob = blob;
                    t.rcIsUploaded = true;
                    t.f.rc_img_url = getObjectURL(blob);
                }

                else if (t.uploadImgType == 'avatar') {
                    t.avatarImageBlob = blob;
                    t.avatarIsUploaded = true;
                    t.f.avatar_url = getObjectURL(blob);
                }

                t.closeCropper();
            });
        },

        uploadRC() {

            let t = this;

            t.uploadImgType = 'rc';

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById('cropperImg');

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 4 / 3,
                        autoCropArea: 1,
                        crop(event) {
                        },
                    });
                    $('.cropper-item').show();
                }

                event.target['value'] = '';


            };

            ImageUploader.openSelector();
        },

        uploadAvatar() {

            let t = this;

            t.uploadImgType = 'avatar';

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById('cropperImg');

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 1 / 1,
                        autoCropArea: 1,
                        crop(event) {
                        },
                    });
                    $('.cropper-item').show();
                }

                event.target['value'] = '';


            };

            ImageUploader.openSelector();
        },

        saveProfile() {
            let t = this;
            let f = t.f;

            if (t.busying)
                return;

            let go = true;

            if (!f.tel) {
                A.err('Telephone number is Required.');
                go = false;
            }

            if (!f.email) {
                A.err('Email is Required.');
                go = false;
            }

            if (!/^[a-zA-Z0-9\.]{1,}@[a-zA-Z0-9\.]{1,}[a-zA-Z0-9]$/.test(f.email)) {
                A.err('Please enter a valid email address.');
                go = false;
            }

            if (!f.emergency_tel) {
                A.err('Emergency telephone number is Required.');
                go = false;
            }

            if (!f.emergency_contact_name) {
                A.err('Emergency contact name is Required.');
                go = false;
            }

            if (!f.address) {
                A.err('Address is Required.');
                go = false;
            }

            if (f.birthday_year && f.birthday_month && f.birthday_day) {

                let year = Number(f.birthday_year),
                    month = Number(f.birthday_month),
                    day = Number(f.birthday_day);

                const date = new Date(year, month - 1, day);

                if (date instanceof Date &&
                    !isNaN(date.getTime()) &&
                    date.getDate() === day &&
                    date.getMonth() === month - 1 &&
                    date.getFullYear() === year) {
                    f.birthday = f.birthday_year + '/' + f.birthday_month + '/' + f.birthday_day;
                }
                else {
                    A.err('Birthday is not Valid.');
                    go = false;
                }
            }
            else {
                A.err('Birthday is not Valid.');
                go = false;
            }

            if (!go)
                return;

            t.busying = true;

            let data = getFields(f, ['address', 'email', 'tel', 'emergency_tel', 'emergency_contact_name', 'rc_img_url', 'avatar_url', 'gender', 'birthday', 'desc', 'firstname', 'lastname', 'code1', 'code2', 'country']);

            let fd = new FormData();

            for (const key in data) {
                fd.append(key, data[key]);
            }

            if (t.rcIsUploaded)
                fd.append('rc_image', t.rcImageBlob);

            if (t.avatarIsUploaded)
                fd.append('avatar_image', t.avatarImageBlob);

            t.busying = true;

            t.editName = false;

            axios.post('employee/saveProfile', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {

                t.busying = false;

                t.avatarImageBlob = null;
                t.avatarIsUploaded = false;
                t.rcImageBlob = null;
                t.rcIsUploaded = false;

                if (res.data.status == 1) {
                    localStorage['_m'] = JSON.stringify(res.data.options.item);
                    copyFrom(t.U, res.data.options.item);
                    copyFrom(t.f, t.U);
                    A.toast('Saved.');
                    t.$forceUpdate();
                }
            });
        },

        saveName() {
            let t = this;
            let f = t.f;

            if (t.busying)
                return;

            let go = true;


            if (!f.lastname) {
                A.err('Lastname is Required.');
                go = false;
            }

            if (!f.firstname) {
                A.err('Firstname is Required.');
                go = false;
            }

            if (!go)
                return;

            t.busying = true;

            let data = getFields(f, ['firstname', 'lastname']);

            let fd = new FormData();

            for (const key in data) {
                fd.append(key, data[key]);
            }

            t.busying = true;

            t.editName = false;

            axios.post('employee/saveProfile', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    localStorage['_m'] = JSON.stringify(res.data.options.item);
                    copyFrom(t.U, res.data.options.item);
                    copyFrom(t.f, t.U);
                    A.toast('Saved.');
                    t.$forceUpdate();
                }
            });
        },

        loadMonthlyStats() {

            let t = this;

            let dayIndexs = ['日', '月', '火', '水', '木', '金', '土'];

            t.list.dateGrid.clear();

            let url = 'cleanTask/readMonthly/';

            if (t.U.is_driver) {
                url = 'cleanTask/readMonthly_sup/';
            }

            axios.post(url + t.year + '/' + t.month).then(res => {
                if (res.data.status == 1) {

                    let dictDate = {};

                    let todayText = (new Date()).format('MM/dd');
                    let todayVal = new Date();

                    let startDate = new Date(res.data.options.start_date);
                    let endDate = new Date(res.data.options.end_date);

                    let i = 0;

                    while (true) {
                        let curDate = new Date(res.data.options.start_date);
                        curDate.setDate(curDate.getDate() + i);
                        if (curDate > endDate)
                            break;
                        let date = curDate.format('MM/dd');
                        let dayIndex = dayIndexs[curDate.getDay()];
                        let item = {
                            date: date,
                            day_index: dayIndex,
                            week_index: curDate.getDay(),
                            tasks: [],
                            is_today: date == todayText,
                            is_past: curDate < todayVal
                        };
                        dictDate[date] = item;

                        // if (date == '04/15') {
                        //     t.focusDateItem = item;
                        // }
                        t.list.dateGrid.push(item);
                        i++;
                    }

                    let arr = res.data.options.items;

                    arr.forEach(task => {
                        let date = new Date(task.date).format('MM/dd');
                        let item = dictDate[date];
                        item.tasks.push(task);
                    });
                }
            });

        },

        minusMonth() {
            let t = this;
            let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), -1);
            t.month = r.getMonth() + 1;
            t.year = r.getFullYear();
            t.loadMonthlyStats();
        },

        plusMonth() {
            let t = this;
            let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), 1);
            t.month = r.getMonth() + 1;
            t.year = r.getFullYear();
            t.loadMonthlyStats();
        },

        onSelectCountry(item) {
            this.f.country = item.code;
        },

        focusInput() {
            document.getElementById('txtEmail').focus();
        },

        openFocusDateItem(item) {
            let t = this;
            console.log(item);

            if (item.tasks.length > 0)
                t.focusDateItem = item;
        },

        tapFocusDateItem(task) {
            let t = this;

            if (task.next_checkin_order && task.next_checkin_order.emergency_status == 3 && task.noticed != 1) {
                task.noticed = 1;
                axios.post('cleanTask/markNoticed/' + task.id);
            }
        }
    },
    data() {
        return {
            focusDateItem: null,
            hideNav: false,
            lastJSON: '',
            stats: {
                unread: 0,
                cleaned: 0,
                clean_task_sendback_report:0,
                today_unfinished_clean_task:0,
                _tick: 0,
            },
            showSetting: false,
            year: (new Date()).getFullYear(),
            month: (new Date()).getMonth() + 1,
            selectedDate: null,
            minDate: new Date('1950/01/01'),
            maxDate: new Date('2023/01/01'),
            showCalendar: false,
            showModifyPwd: false,
            loading: false,
            replacingIndex: null,
            currentTask: null,
            view: 'chat',
            oldView: '',
            todayDateStr: ' ',
            realtimeStr: '',
            dict: {
                country: {},
                editingTask: {},
                cleanArea: {}
            },
            list: {
                country: [],
                cleanArea: [],
                cleanTask: [],
                startedCleanTask: [],
                roomArea: [],
                uploadQueue: [],
                blobs: [],
                dateGrid: []
            },

            //profile
            editName: false,
            f: {
                firstname: '',
                lastname: '',
                gender: 1,
                address: '',
                email: '',
                tel: '',
                birthday: '',
                emergency_tel: '',
                emergency_contact_name: '',
                desc: '',
                rc_img_url: '',
                avatar_url: '',
                id: '',
                country: '',
                code1: '',
                code2: '',
                birthday_year: '',
                birthday_month: '',
                birthday_day: ''
            },
            rcIsUploaded: false,
            rcImageBlob: null,
            avatarIsUploaded: false,
            avatarImageBlob: null,
            cropper: null,
            uploadImgType: '',

            //attendace
            attendanceExpanded: true,

            //clean task log
            ctl: {
                view: 1,
                total: 0
            },

            showCountryPopover: false,
            showInfo: false

        };
    },
    computed: {
    }
};
